function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_454_10089",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 12H35C35 31.33 19.33 47 0 47V12Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12H35C35 31.33 19.33 47 0 47V12Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12H35H0ZM35.5 12C35.5 31.6061 19.6061 47.5 0 47.5H-2L2 46.5H0C19.0538 46.5 34.5 31.0538 34.5 12H35.5ZM-2 47.5V12H2V46.9438L1.99995 46.9428C1.33398 46.9809 0.667053 47 -6.11959e-06 47L-2 47.5ZM35.5 12C35.5 31.6061 19.6061 47.5 0 47.5V46.5C19.0538 46.5 34.5 31.0538 34.5 12H35.5Z",
  fill: "#B0B0B0",
  mask: "url(#path-1-inside-1_454_10089)"
});

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-2_454_10089",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H35V13H0V0Z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H35V13H0V0Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0V-1C-0.552285 -1 -1 -0.552285 -1 0L0 0ZM35 0H36C36 -0.552285 35.5523 -1 35 -1V0ZM0 1H35V-1H0V1ZM34 0V13H36V0H34ZM1 13V0H-1V13H1Z",
  fill: "#B0B0B0",
  mask: "url(#path-3-inside-2_454_10089)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1 12.5L34 12.5",
  stroke: "#B0B0B0",
  strokeDasharray: "2 2"
});

var SvgDoorLeft = function SvgDoorLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 47,
    viewBox: "0 0 35 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoorLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doorLeft.dcd16dd8.svg";
export { ForwardRef as ReactComponent };